/* (ignored) */


//////////////////
// WEBPACK FOOTER
// net (ignored)
// module id = 4
// module chunks = 2